import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=07ff2854&scoped=true"
import script from "./ErrorModal.vue?vue&type=script&lang=js"
export * from "./ErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ErrorModal.vue?vue&type=style&index=0&id=07ff2854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff2854",
  null
  
)

export default component.exports